import { render, staticRenderFns } from "./_sns_post_sales.vue?vue&type=template&id=723262c4&"
import script from "./_sns_post_sales.vue?vue&type=script&lang=js&"
export * from "./_sns_post_sales.vue?vue&type=script&lang=js&"
import style0 from "./_sns_post_sales.vue?vue&type=style&index=0&id=723262c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports